<template>
  <div id="transmision_manifestacion">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card color="primary" icon="library_books" title="Bitácora de Carga de Layouts"
            class="elevation-1 px-5 py-3">




            <v-card-text>

              <v-form ref="formreporte" lazy-validation>
                <v-container grid-list-md text-xs-center>

                  <v-row row wrap>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary"
                            prepend-icon="event" @blur="
                              fecha_de = parseDate(fecha_de)
                              " v-mask="'####-##-##'" :rules="[
                                rules.required,
                                validaDias,
                                validaFecha,
                                $rules.validaDiasConsulta(fecha_de, fecha_a)
                              ]">
                          </v-text-field>
                        </template>

                        <v-date-picker v-model="fecha_de" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary"
                            prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[
                              rules.required,
                              validaDias,
                              validaFecha,
                              $rules.validaDiasConsulta(fecha_de, fecha_a)
                            ]"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_a" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col sm="12" md="2" lg="2">
                      <v-btn rounded color="secondary" @click="cargar()">
                        <v-icon>search</v-icon>Consultar
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-container>
              </v-form>
              <div id="datagrid">

                <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options"
                  class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                  </template>
                  <template slot="error" slot-scope="props">
                    <div class="columnaError">
                      {{ props.row.error }}
                    </div>
                  </template>
                  <template slot="estatus" slot-scope="props">
                    <div v-if='props.row.estatus != "Transmitido con errores"'>
                      {{ props.row.estatus.toUpperCase() }}
                    </div>
                    <div :title="props.row.error" v-if="props.row.estatus == 'Transmitido con errores'"
                      style="color:red">

                      <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn text color="error" v-bind="attrs" v-on="on" :title="props.row.error">
                            <u>Transmitido con errores</u>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="text-h5 red lighten-2">
                            TRANSMITIDO CON ERRORES
                          </v-card-title>

                          <v-card-text>
                            {{ props.row.error }}
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog = false">
                              Cerrar
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </template>
                  <template slot="actions" slot-scope="props">

                    <v-row>

                      <v-col sm="12" md="2" lg="2"
                        v-if="props.row.estatus == 'Transmitido y Consultado' || props.row.estatus == 'Transmitido con errores'">

                        <v-speed-dial direction="left" open-on-hover>
                          <template v-slot:activator>
                            <v-btn x-small fab dark color="secondary" title="Descarga Comprobantes" v-tippy>
                              <v-icon v-if="fab">mdi-close</v-icon>
                              <v-icon v-else>mdi-file-multiple</v-icon>
                            </v-btn>
                          </template>
                          <v-btn x-small fab dark color="red" v-if="props.row.estatus == 'Transmitido y Consultado'"
                            @click.native="downloadFile(props.row.rfc + '/manifestacion/' + props.row.id + '/' + props.row.json_consulta_response.eDocument + '.pdf')"
                            title="PDF Manifestación" v-tippy>
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>

                          <v-btn x-small fab dark color="orange" v-if="props.row.estatus == 'Transmitido y Consultado'"
                            @click.native="downloadFile(props.row.rfc + '/manifestacion/' + props.row.id + '/Acuse_' + props.row.json_consulta_response.eDocument + '.pdf')"
                            title="PDF Acuse Manifestación" v-tippy>
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="blue" v-if="props.row.datosComplementarios == 1 && false"
                            @click.native="downloadFormatoE2(props.row)" title="Formato E2" v-tippy>
                            <v-icon>mdi-file-document-outline</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="grey"
                            v-if="props.row.estatus == 'Transmitido y Consultado' || props.row.estatus == 'Transmitido con errores'"
                            @click.native="generaZipEvidencia(props.row.id)" title="Zip Evidencias" v-tippy>
                            <v-icon>mdi-folder-zip-outline</v-icon>
                          </v-btn>
                        </v-speed-dial>
                      </v-col>
                      <v-col sm="12" md="8" lg="8">

                        <v-btn x-small fab dark color="primary"
                          @click.native="vistaPrevia(props.row.id, props.row.nombre_proceso)"
                          title="Consultar Manifestación" v-tippy>
                          <v-icon>mdi mdi-window-restore</v-icon>
                        </v-btn>


                      </v-col>
                    </v-row>
                  </template>
                </v-client-table>
              </div>

            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>









    <!-- MODAL PARA VISTA PREVIA-->
    <v-dialog v-model="dialogVP" max-width="95%">
      <v-card>

        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="dialogVP = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Consultar Manifestación</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-vista-previa :key="keyVistaPrevia" />

        </v-card-text>
      </v-card>


    </v-dialog>






  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

import RefreshButton from "@/components/RefreshButton.vue";
import VistaPrevia from "@/views/manifestacion_valor/VistaPrevia.vue";

export default {
  components: { "v-refresh-button": RefreshButton, "v-vista-previa": VistaPrevia },

  data: () => ({
    manifestacion_seleccionada: "",
    solicitudes_manifestacion_actual: [],
    solicitudes: [],
    patentes: [],
    agentes_patentes: [],
    permisoPatentes: "",
    type_file: "",
    archivo_original: "",
    keyVistaPrevia: "",
    dialog1: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialogVP: false,
    dialog: false,
    fecha_de: "",
    fecha_a: "",
    fecha_factura: false,
    manifestacion_actual: "",
    id_manifestacion_actual: "",
    curp_actual: "",
    lista_coves_recuperacion: [],
    lista_edocs_recuperacion: [],

    dialogRecuperaciones: false,
    manifestacionSeleccionada: "",
    lista_filtrada: [],
    lista_filtrada_nuevo: [],
    lista_filtrada_coves: [],
    lista_filtrada_coves_nuevo: [],

    tiposManifestacion: [
      //{"clave":"global","nombre":"Global"},
      { "clave": "operacion", "nombre": "Por Operación" },
      { "clave": "operacion-consolidado", "nombre": "Por Operación-Consolidado" },
      //{"clave":"muestra","nombre":"Muestra Representantiva"},
    ],
    tiposMomentos: [
      { "clave": "previo", "nombre": "Previo al Despacho" },
      { "clave": "durante", "nombre": "Durante el Despacho" },
      //{"clave":"despues","nombre":"Después del Despacho"},
    ],
    model: {
      id: "",
      nombre_proceso: "",
      tipo_manifestacion: "",
      momento_transmision: "",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      usuario_email: "",
      rfc_consulta: [],
    },
    model_nuevo: {
      no_pedimento: "",
      fecha_pedimento: "",
      rfc: "",
      tipo_manifestacion: "",
      momento_transmision: "durante",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      rfc_emisor: "",
      rfc_consulta: [],
      ejercicio_fiscal: "",
    },
    model_nuevo_vacio: {
      no_pedimento: "",
      fecha_pedimento: "",
      rfc: "",
      tipo_manifestacion: "",
      momento_transmision: "durante",
      lista_solicitudes: [],
      lista_edocuments: "",
      lista_coves: "",
      rfc_representante: "",
      terceros_autorizados: [],
      rfc_emisor: "",
      ejercicio_fiscal: "",
    },
    nombresRfcConsulta: {},
    fab: false,
    menu1: false,
    menu2: false,
    menu3: false,
    file: "",
    ext_file: "",
    unidadesMedida: [],
    tiposMoneda: [],
    paises: [],
    modalPdfCove: false,
    modalPlantilla: false,
    idCoveVistaPrevia: "",
    detalle_factura: [],
    showImages: true,
    name: "datagrid",
    importData: [],
    nombre_proceso: "",
    modal: false,
    modalManifestacion: false,
    cliente: '',
    usuario: '',
    rfc: '',
    columns: [
      "fecha",
      "filename",
      "tipo",
      "mensaje",
    ],
    options: {
      filterable: [
        "fecha",
        "filename",
        "tipo",
        "mensaje",
      ],
      sortable: [
        "fecha",
        "filename",
        "tipo",
        "mensaje",
      ],

      headings: {
        "fecha": "Fecha",
        "filename": "Archivo",
        "tipo": "Tipo de Layout",
        "mensaje": "Estatus",
      },
      uniqueKey: "id",
    },

    rules: {
      required: v => !!v || "Este campo es requerido",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Correo electrónico no valido";
      },
    },

    URL: "",
    show_loading: true,
    breadcrumbs: [{
      text: "Inicio",
      disabled: false,
      to: "/home"
    },
    {
      text: "EManifiesto",
      disabled: true,
      to: ""
    },
    {
      text: "Bitácora de Carga",
      disabled: true,
      to: ""
    }
    ],
    emisores: [],
    rfcs_consulta: [],
    representantes: [],
    sellos: [],
    ws_password: '',

    registros: {
      selected: [],
      items: [],
    },
    facturas: {
      items: [],
      camposexcel: {
        "no_factura": "no_factura",
        "no_operacion": "no_operacion",
        "nombre_cove": "nombre_cove",
        "partidas": "partidas",
        "estatus": "estatus",
        "error": "error",
        "errores": "errores",
      },
    },
    columnsFacturas: [
      "no_factura",
      "no_operacion",
      "nombre_cove",
      "partidas",
      "estatus",
      "error",
      "errores",
      "xml",
      "pdf",
      "acuse",
    ],
    optionsFacturas: {
      filterable: [
        "no_factura",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "error",
      ],
      sortable: [
        "no_factura",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "error",
      ],
      headings: {
        no_factura: "Factura",
        o_operacion: "No. Operación",
        nombre_cove: "COVE",
        partidas: "Partidas",
        estatus: "Estatus",
        error: "Error Transmisión",
        errores: "Error Recuperación",
        xml: "XML",
        pdf: "PDF",
        acuse: "Acuse",
      }
    },
    dataRecuperaciones: [],
    columnsRecuperaciones: [
      "nombre",
      "tipo",
      "estatus",
      'fecha',
      "detalle",
      'error'
    ],


    registro_seleccionado: '',



  }),

  methods: {


    validaDias: function () {
      if (this.fecha_de != "" && this.fecha_a != "") {
        var inicio = moment(this.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, "days");
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 365)
          return "Periodo máximo de consulta 365 dias. Favor de verificar.";
      }
      return true;
    },
    validaPedimento: function (val) {
      if (val != null && val != "") {
        if (!this.validarPatronPedimento(val))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      }
      return true;
    },
    validaPatentePermitida: function (val) {
      if (val != null && val != "" && this.permisoPatentes == "100" && this.agentes_patentes.length) {
        var split = val.split("-");
        try {
          console.log(split[1]);
          var patente = split[1].toString();
          if (!this.agentes_patentes.includes(patente))
            return "Patente no permitida. Revise su catálogo de agentes aduanales.";
        } catch (error) {
          return true;
        }

      }
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaFecha: function (fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida.";
      else
        return true;
    },
    validaAnio: function () {
      if (this.model_nuevo.fecha_de != "" && this.model_nuevo.fecha_a != "") {
        var inicio = moment(this.model_nuevo.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model_nuevo.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (inicio.year() > moment().year() || fin.year() > moment().year())
          return "Las fechas no deben ser mayor al año actual."
      }
      return true;
    },
    setListValues: function () {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista_edocuments);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
    },
    setListValuesCoves: function () {
      this.lista_filtrada_coves = [];
      let to_list = this.get_array_lista(this.model.lista_coves);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_coves.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_coves.push(to_list[i]);
        }
      }
    },
    setListValuesNuevo: function () {
      this.lista_filtrada_nuevo = [];
      let to_list = this.get_array_lista(this.model_nuevo.lista_edocuments);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_nuevo.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_nuevo.push(to_list[i]);
        }
      }
    },
    setListValuesCovesNuevo: function () {
      this.lista_filtrada_coves_nuevo = [];
      let to_list = this.get_array_lista(this.model_nuevo.lista_coves);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada_coves_nuevo.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada_coves_nuevo.push(to_list[i]);
        }
      }
    },
    get_array_lista: function (cadena) {
      try {
        var newarr = [];
        if (cadena != undefined && typeof cadena == "string") {
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
          return newarr;
        } else if (cadena != null && typeof cadena == "object")
          return cadena;

      } catch (error) {
        console.log(error);
      }
    },
    set_coves_modelo: function () {
      //de las referencias en model.lista_solicitudes obtener los coves y ponerlos en this.model.lista_coves
      //y mandar llamar el metodo de setListValuesCoves y setListValues
      if (this.model.tipo_manifestacion == "operacion") {//Si es por operación quitamos la lista de solicitudes
        this.model.lista_solicitudes = [];
      }
      this.model.lista_coves = "";
      this.model.lista_edocuments = "";
      var solicitudes_seleccionadas = this.solicitudes.filter(e => { return this.model.lista_solicitudes.includes(e.descripcion) });
      for (var keysolicitud in solicitudes_seleccionadas) {
        if (solicitudes_seleccionadas[keysolicitud].tipo == "cove") {
          var str_cove = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model.lista_coves = str_cove;
        }
        else if (solicitudes_seleccionadas[keysolicitud].tipo == "edocument") {
          var str_edoc = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model.lista_edocuments = str_edoc;
        }
      }
      this.setListValuesCoves();
      this.setListValues();
    },
    set_coves_modelo_nuevo: function () {
      //de las referencias en model_nuevo.lista_solicitudes obtener los coves y ponerlos en this.model_nuevo.lista_coves
      //y mandar llamar el metodo de setListValuesCovesNuevo y setListValuesNuevo
      if (this.model_nuevo.tipo_manifestacion == "operacion") {//Si es por operación quitamos la lista de solicitudes
        this.model_nuevo.lista_solicitudes = [];
      }
      this.model_nuevo.lista_coves = "";
      this.model_nuevo.lista_edocuments = "";
      var solicitudes_seleccionadas = this.solicitudes.filter(e => { return this.model_nuevo.lista_solicitudes.includes(e.descripcion) });
      for (var keysolicitud in solicitudes_seleccionadas) {
        if (solicitudes_seleccionadas[keysolicitud].tipo == "cove") {
          var str_cove = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model_nuevo.lista_coves = str_cove;
        }
        else if (solicitudes_seleccionadas[keysolicitud].tipo == "edocument") {
          var str_edoc = solicitudes_seleccionadas[keysolicitud].archivos.join("\n");
          this.model_nuevo.lista_edocuments = str_edoc;
        }
      }
      this.setListValuesCovesNuevo();
      this.setListValuesNuevo();
    },
    maxListaRule: function () {
      if (this.model.lista_edocuments == '' || this.model.lista_edocuments == undefined || Array.isArray(this.model.lista_edocuments)) {
        return "Lista vacia";
      }
      let x = this.model.lista_edocuments.split("\n");
      if (x.length > 50) {
        return "No se puede agregar más de 50 eDocs";
      }
      return true;
    },


    openModal: function (row) {
      this.cargarSolicitudes(row.id);
      this.model.id = row.id;
      this.model.nombre_proceso = row.nombre_proceso;
      this.model.tipo_manifestacion = row.tipo_manifestacion;
      this.model.momento_transmision = row.momento_transmision;
      //this.model.ejercicio_fiscal = row.ejercicio_fiscal;
      this.model.lista_solicitudes = row.lista_solicitudes;
      this.model.rfc_consulta = row.rfc_consulta;
      this.model.lista_edocuments = row.lista_edocuments;
      this.model.lista_coves = row.lista_coves;
      this.model.rfc_representante = row.rfc_representante;
      this.model.terceros_autorizados = row.terceros_autorizados;
      this.setListValuesCoves();
      this.setListValues();
      this.modalManifestacion = true;
    },
    validaEntero(numero) {
      if (numero != null) {
        const pattern = /^[\d]*$/;
        if (pattern.test(numero) && numero.length == 4) {
          if (numero > moment().year())
            return "El año no debe ser mayor al año actual"
          else
            return true;
        }
        else
          return "Ingrese un año válido";
      }
      return true;
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateExcel(excelDate) {
      try {
        if (!excelDate) return false;
        var fecha = '';
        if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
          fecha = moment(String(excelDate)).format("YYYY-MM-DD");
        else
          fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
        if (fecha == 'Invalid date') return false;
        return fecha;
      } catch (error) {
        return false;
      }
    },
    cargar: function () {

      //  if (!this.$refs.formreporte.validate()) {
      //Alguna operación o mensaje
      //   console.log('entra aqui');
      //  } else {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');



      var datos = {
        rfc: this.rfc,
        fecha_de: this.fecha_de,
        fecha_a: this.fecha_a,
      };

      axios
        .post(this.URL + "listar_logs_layouts_mve/", datos)
        .then(res => {
          console.log(res);
          if (typeof res.data !== "undefined") {
            this.registros.items = res.data.data;
          
            this.registros.items.sort(function (a, b) {
               return new Date(b.fecha) - new Date(a.fecha) ;
            });
            for (var k in this.registros.items) {

              this.registros.items[k].fecha = this.parseDate(this.registros.items[k].fecha);

            }
          }
        })
        .catch(err => {

          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
      // }

    },
    getCadena: function (arr) {
      if (arr != null && typeof arr == "object") {
        var cadena = ""
        for (var k in arr) {
          cadena += arr[k]["nombre"].toString() + "\n";
        }
        return cadena;
      } else
        return arr;
    },
    getEstatus: function (Datos, estatus) {
      var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores", "Transmitiendo", "Transmitido y Consultado"];
      if (estatus in arr_estatus) {
        if (arr_estatus[estatus] == "Sin transmitir" && (Datos.rfc_representante == null || Datos.rfc_representante == ""))
          return "Completar registro";
        else if (arr_estatus[estatus] == "Sin transmitir" && Datos.datosManifestacionValor == 0)
          return "Incrementables no cargados";
        else
          return arr_estatus[estatus];
      }
      else
        return "N/A";
    },
    getEstatusDetalle: function (estatus) {
      var arr_estatus = ["Pendiente", "Transmitido", "Aceptado", "Rechazado"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },

    verificaMaxlen: function (results) {
      var errores = '';

      for (var key in this.maxLen) {
        if (key == "RFC's de consulta" && results[key] != null) {
          var rfcs = results["RFC's de consulta"].split(",");
          for (var r in rfcs) {
            if (rfcs[r].toString().trim().length > this.maxLen[key]) {
              errores += '<br/>' + "- El campo " + key + ":'" + rfcs[r].toString().trim() +
                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
            }
          }
        }
        else if (key == "eDocument" && results[key] != null) {
          var edocs = results["eDocument"].toString().split(",");
          for (var r in edocs) {
            if (edocs[r].toString().trim().length > this.maxLen[key]) {
              errores += '<br/>' + "- El campo " + key + ":'" + edocs[r].toString().trim() +
                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
            }
          }
        } else {
          if (results[key] != null && results[key].toString().trim().length > this.maxLen[key]) {
            errores += '<br/>' + "- El campo " + key + ":'" + results[key].toString().trim() +
              "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
          }
        }

      }

      return errores == '' ? true : errores;
    },
    validaCorreo: function (mail) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(mail);
    },
    cargarRfcsConsulta: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.rfcs_consulta = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los rfcs de consulta.",
            footer: ""
          });
        });
    },
    getNombreRfcConsulta: function (record) {
      return record.rfc + " - " + record.nombre;
    },
    cargarEmisores: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.emisores = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los emisores.",
            footer: ""
          });
        });
    },
    getNombreEmisor: function (record) {
      return record.rfc + " - " + record.razon_social;
    },
    cargarRepresentantes: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/representantes/get_representantes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.representantes = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los representantes legales.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getNombreRepresentante: function (record) {
      return record.rfc + " - " + record.nombre + " " + record.apellido_paterno + " " + record.apellido_materno ;
    },
    cargarSolicitudes: function (id_manifestacion = 0) {
      if (id_manifestacion == 0) {
        var datos = {
          rfc: this.model.rfc
        };
      } else {
        var datos = {
          rfc: this.model.rfc,
          id_manifestacion: id_manifestacion
        };
      }

      axios
        .post(this.$hostname + "vucem/get_solicitudes_manifestacion/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.solicitudes = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las solicitudes de recuperación.",
            footer: ""
          });
        });
    },
    validaTerceros() {
      if (this.model.terceros_autorizados != null && this.model.terceros_autorizados.length == 0) {
        return "Debe seleccionar al menos una persona autorizada";
      }
      return true;
    },
    validaTercerosNuevo() {
      if (this.model_nuevo.terceros_autorizados != null && this.model_nuevo.terceros_autorizados.length == 0) {
        return "Debe seleccionar al menos una persona autorizada";
      }
      return true;
    },
    cargarCertificados: function () {
      var rfc = this.rfc;
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.sellos = res.data;
            if (this.sellos.length > 0) {
              var search = this.sellos.filter(function (e) {
                return e.estatus == 1 && e.activo == true; //1-Sello correcto
              });
              if (search.length > 0) {
                let sello = search[0];
                this.ws_password = sello.clave_ws;
              } else {
                var search2 = this.sellos.filter(function (e) {
                  return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                });
                if (search2.length > 0) {
                  let sello = search2[0];
                  this.ws_password = sello.clave_ws;
                } else {
                  this.$swal({
                    type: "warning",
                    title: "Advertencia",
                    text: "El cliente: " + rfc + " no tiene sellos digitales validados. Favor de verificar.",
                    footer: ""
                  });

                }
              }
            } else {
              this.$swal({
                type: "warning",
                title: "Advertencia",
                text: "No se han configurado sellos digitales para el cliente: " + rfc,
                footer: ""
              });
            }
          }
        })
        .catch(err => {

        });
    },

    verificaEmisor: function (emisor, opcion) {
      if (emisor == undefined)
        return false;

      var search = this.emisores.filter(function (e) {
        return e.rfc.toString().trim().toUpperCase() == emisor.toString().trim().toUpperCase();
      });
      if (opcion == 'domicilio')
        return search.length > 0 ? search[0] : '';
      else
        return search.length > 0;
    },
    formatNumber: function (numero, decimales) {
      if (numero == undefined || numero == null || numero == "")
        numero = 0;
      numero = Number(numero);
      if (isNaN(numero)) {
        return "";
      } else
        return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    //Validamos números Float con punto decimal y que cumpla con el número de decimales
    verificaDecimales: function (valor, numeroDecimales) {
      var cantidad_split = valor.toString().split(".");
      if (cantidad_split.length == 1) {
        if (Number.isNaN(parseInt(cantidad_split[0]))) {
          return false;
        } else
          return parseInt(cantidad_split[0]).toString() + "." + "0".repeat(numeroDecimales);
      } else if (cantidad_split.length == 2) {
        if (Number.isNaN(parseInt(cantidad_split[0])) || Number.isNaN(parseInt(cantidad_split[1]))) {
          return false;
        } else if (cantidad_split[1].toString().length > numeroDecimales) {
          var newNum = Math.round(valor * Math.pow(10, numeroDecimales)) / Math.pow(10, numeroDecimales);
          return this.verificaDecimales(newNum, numeroDecimales);
        } else {
          var repetir = numeroDecimales - cantidad_split[1].toString().length;
          if (repetir == 0)
            return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString();
          else
            return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString() + "0".repeat(repetir);

        }

      } else
        return false;
    },




    consultar_operacion: function (row_id) {
      let datos = { id_manifestacion: row_id };
      axios
        .post(this.$hostname + "manifestacion/consultar_nuevo/", datos)
        .then(() => {

        })
        .catch(err => {
          console.log(err);
        });
    },

    consulta_pedimento: function (idManifestacion) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: idManifestacion,
      };
      axios.post(this.URL + "consulta_pedimento_manifestacion/", datos)
        .then(res => {
          var mensaje = "La manifestación se actualizó correctamente.";
          if (typeof res.data !== "undefined" && res.data.mensaje != undefined) {
            mensaje = res.data.mensaje;
          }
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: mensaje,
            footer: '',
          });
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          var mensaje = "Ocurrió un error al consultar el pedimento de la manifestación. Favor de intentar más tarde.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            mensaje = error.response.data.mensaje;
          }
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          this.$root.$dialogLoader.hide();
          console.log(error);
        });
    },
    downloadZipEvidencia: function (idManifestacion, intento = 0) {
      var nombreZip = idManifestacion.toString() + "_evidencias.zip";
      var key = this.$local_storage.get("rfc") + "/reportes/" + nombreZip;
      var datoss3 = {
        id: key,
        bucket: "production.econnect.ds"
      }

      var thisObj = this;
      axios.post(this.$hostname + 's3/download_url/', datoss3)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);
            this.$root.$dialogLoader.hide();
          } else {
            if (intento > 3) {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al generar ZIP. Favor de intentar nuevamente.",
                footer: '',
              });
              this.$root.$dialogLoader.hide();
            } else {
              setTimeout(function () {
                thisObj.downloadZipEvidencia(idManifestacion, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)
            }

          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;

          if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 3) {
            setTimeout(function () {
              thisObj.downloadZipEvidencia(idManifestacion, intento + 1);
            }, 10000); //Damos tiempo para generar el zip (10 seg)
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            console.log(error);
            this.$root.$dialogLoader.hide();
          }
        });

    },
    generaZipEvidencia: function (idManifestacion) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        rfc: this.$local_storage.get("rfc"),
        id_manifestacion: idManifestacion,
        reporte_url: "/reportes_vucem/zip_evidencias_manifestacion/",
        nombre_reporte: "Zip Evidencias Manifestacion",
        tipo: "ZIP_Evidencias_Manifestacion",
        usuario: this.$local_storage.get("id_usuario"),
      };
      var thisObj = this;
      axios.post(this.$hostname + "reportes/save_reporte/", datos)
        .then(res => {
          setTimeout(function () {
            thisObj.downloadZipEvidencia(idManifestacion, 1);
          }, 10000); //Damos tiempo para generar el zip (10 seg)
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
          } else {//Si es un timeout intentamos descargar el archivo
            setTimeout(function () {
              thisObj.downloadZipEvidencia(idManifestacion, 1);
            }, 10000); //Damos tiempo para generar el zip (10 seg)
          }
          console.log(error);
        });
    },
    downloadLayoutMV: function (idManifestacion, intento = 0) {

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre
        this.generaLayoutMV(idManifestacion);
      } else {
        var nombreKey = idManifestacion.toString() + "_LAYOUT_MV.xlsx";
        var key = this.$local_storage.get("rfc") + "/manifestacion/" + idManifestacion + "/" + nombreKey;
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }

        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar el layout. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                setTimeout(() => { this.downloadLayoutMV(idManifestacion, intento + 1); }, 4000);
              }

            }
          })
          .catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              setTimeout(() => { this.downloadLayoutMV(idManifestacion, intento + 1); }, 4000);
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }
    },




    downloadFile: function (key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      let nombre_download = key.split("/").pop();

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadVistaPrevia: function (row, intento = 0) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre, ya que pueden actualizar el alyout y para que se descargue actualizada
        this.generaVistaPrevia(row);
      } else {
        var key = row.rfc + "/manifestacion/" + row.id.toString() + "/" + row.id.toString() + "_vista_previa.pdf";
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }
        let nombre_download = key.split("/").pop();

        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                this.downloadVistaPrevia(row, intento + 1);
              }

            }
          }).catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              this.downloadVistaPrevia(row, intento + 1);
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }

    },
    generaVistaPrevia: function (row) {
      var datos = {
        id: row.id,
      };
      axios.post(this.URL + "pdf_acuse_detalle_preview/", datos)
        .then(res => {
          this.downloadVistaPrevia(row, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            this.$root.$dialogLoader.hide();
          } else {//Si es un timeout intentamos descargar el archivo
            this.downloadVistaPrevia(row, 1);
          }
          console.log(error);
        });
    },
    downloadFormatoE2: function (row, intento = 0) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      if (intento == 0) {//Se generara siempre, ya que pueden actualizar el layout y para que se descargue actualizado
        this.generaFormatoE2(row);
      } else {
        var key = row.rfc + "/manifestacion/" + row.id.toString() + "/" + row.id.toString() + "_e2.pdf";
        var datoss3 = {
          id: key,
          bucket: "production.econnect.ds"
        }
        let nombre_download = key.split("/").pop();
        var thisObj = this;
        axios.post(this.$hostname + 's3/download_url/', datoss3)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = res.data.mensaje;
              a.target = '_blank';
              a.click();
              a.parentNode.removeChild(a);
              this.$root.$dialogLoader.hide();
            } else {
              if (intento > 4) {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                  footer: '',
                });
                this.$root.$dialogLoader.hide();
              } else {
                setTimeout(function () {
                  thisObj.downloadFormatoE2(row, intento + 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
              }

            }
          }).catch((error) => {
            var mensaje = "Ocurrió un error al descargar el archivo";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;

            if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
              setTimeout(function () {
                thisObj.downloadFormatoE2(row, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)
            } else {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
              this.$root.$dialogLoader.hide();
            }
          });
      }

    },
    generaFormatoE2: function (row) {
      var datos = {
        id: row.id,
      };
      axios.post(this.URL + "generar_pdf_e2/", datos)
        .then(res => {
          this.downloadFormatoE2(row, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            this.$root.$dialogLoader.hide();
          } else {//Si es un timeout intentamos descargar el archivo
            this.downloadFormatoE2(row, 1);
          }
          console.log(error);
        });
    },
    cargarDetalleFactura: function (idCove) {
      this.$swal({
        type: "info",
        title: "Operación No Disponible",
        text: "Está función aún no se ha desarrollado",
        footer: ""
      });
      return false;

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.idCoveVistaPrevia = idCove;
      var datos = {
        id_cove: idCove
      };
      axios
        .post(this.URL + "get_detalle_factura_coves/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.detalle_factura = res.data.detalle;
            this.nombresRfcConsulta = res.data.nombres;
            this.modalPdfCove = true;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el detalle del cove. Favor de comunicarse con soporte.",
            footer: ""
          });
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    vistaPrevia: function (id, nombre_proceso) {
      this.$local_storage.set("id_manifestacion", id);
      this.$local_storage.set("nombre_manifestacion", nombre_proceso);
      this.keyVistaPrevia = nombre_proceso + "-" + moment().format("YYYYMMDD-HH:mm:ss");
      this.dialogVP = true;
    },
    getRecuperaciones: function (row) {
      let self = this;

      this.manifestacion_actual = row.nombre_proceso;
      this.curp_actual = row.curp;
      let b = row.lista_coves_recuperaciones;
      let c = row.lista_edocs_recuperaciones;

      this.getDetalleDocumentos(b, c, row);


    },
    GetidSellos(curp) {

      var patentes = this.patentes;
      const ix = patentes.findIndex(c => c.curp === curp);
      if (ix >= 0)
        return patentes[ix].id;
      else
        return 0;

    },
    getPatentes: function () {
      let self = this;
      var data = {
        cliente: this.$local_storage.get("rfc"),
      };
      axios
        .post(
          this.$hostname + "catalogos/certificados/list_certificados_agentes/",
          data
        )
        .then(res => {
          if (typeof res.data !== "undefined") {
            self.patentes = res.data;

          }
        })
        .catch(err => {

          console.log(err);
        });
    },
    getDetalleDocumentos: function (b, c, row) {
      let self = this;
      let estatus = ["Pendiente", "Recuperado", "No Recuperado"];
      let tipo = ["", "Archivo M", "Adjunto", "Remesa", "eDoc/Cove Transmitido"];
      let coves = [];
      b.forEach(function (item) {
        coves.push(item.nombre);
      })

      let edocs = [];
      c.forEach(function (item) {
        edocs.push(item.nombre);
      })

      var data = {
        rfc: this.$local_storage.get("rfc"),
        coves: coves,
        edocs: edocs
      };

      axios
        .post(this.$hostname + "vucem/detalle_documentos_manifestacion/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {

            let a = b.concat(c);
            self.dataRecuperaciones = a;

            console.log(res.data);

            if (a.length > 0)
              self.dataRecuperaciones.forEach(function (r) {
                if (typeof r.estatus != 'string') {
                  r.estatus = estatus[r.estatus];
                  r.fecha = self.parseDate(r.fecha);
                  r.tipo = tipo[r.tipo];
                  if (r.nombre.substring(0, 4) == "COVE") {

                    let cove = res.data.coves.filter(a => a.cove == r.nombre)
                    if (cove.length > 0)
                      r.detalle = cove[0].factura;

                  } else {
                    let edoc = res.data.edocs.filter(a => a.eDocument == r.nombre)
                    if (edoc.length > 0)
                      r.detalle = edoc[0].nombre_original;

                  }

                }


              });
            if (row.lista_coves_recuperaciones.length > 0)
              self.lista_coves_recuperacion = row.lista_coves_recuperaciones.filter(a => a.estatus == 'No Recuperado' || a.estatus == 'Pendiente');

            if (row.lista_edocs_recuperaciones.length > 0)
              self.lista_edocs_recuperacion = row.lista_edocs_recuperaciones.filter(a => a.estatus == 'No Recuperado' || a.estatus == 'Pendiente');

            self.dialogRecuperaciones = true;
          }
        })
        .catch(err => {

          console.log(err);
        });
    },
    getAgentesPatentes: function () {
      var datos = {
        cliente: this.$local_storage.get("id_cliente")
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            var agentes = res.data;

            for (var k in agentes) {
              this.agentes_patentes.push(agentes[k].patente.toString());
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    crearprocesoCoves(id_agente) {
      let self = this;
      let archivos = [];
      self.lista_coves_recuperacion.forEach(function (c) {
        archivos.push({ 'cove': c.nombre })
      });

      let data = {
        "rfc": self.model.rfc,
        "tipo_clave_ws": 0,
        "id_certificado": 0,
        "archivos": archivos,
        "descripcion": self.manifestacion_actual,
        "id_manifestacion": self.id_manifestacion_actual,
        "id_usuario": self.$local_storage.get("id_usuario"),
        "id_cliente": self.$local_storage.get("id_cliente")

      };

      axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data)
        .then(res => {
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
        });
      if (id_agente > 0) {
        let data2 = {
          "rfc": self.model.rfc,
          "tipo_clave_ws": 1,
          "id_certificado": id_agente,
          "archivos": archivos,
          "descripcion": self.manifestacion_actual,
          "id_manifestacion": self.id_manifestacion_actual,
          "id_usuario": self.$local_storage.get("id_usuario"),
          "id_cliente": self.$local_storage.get("id_cliente")

        };

        axios.post(self.$hostname + "vucem/solicitud_coves_agente/", data2)
          .then(res => {
          })
          .catch(err => {
            console.log(err);
          }).then(() => {
          });

      }


    },
    crearprocesoEdocs(id_agente) {
      let self = this;
      let archivos = [];
      self.lista_edocs_recuperacion.forEach(function (c) {
        archivos.push({ 'edocument': c.nombre })
      });
      let data = {
        "rfc": self.model.rfc,
        "tipo_clave_ws": 0,
        "id_certificado": 0,
        "archivos": archivos,
        "descripcion": self.manifestacion_actual,
        "id_manifestacion": self.id_manifestacion_actual,
        "id_usuario": self.$local_storage.get("id_usuario"),
        "id_cliente": self.$local_storage.get("id_cliente")

      };

      axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data)
        .then(res => {
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
        });

      if (id_agente > 0) {
        let data2 = {
          "rfc": self.model.rfc,
          "tipo_clave_ws": 1,
          "id_certificado": id_agente,
          "archivos": archivos,
          "descripcion": self.manifestacion_actual,
          "id_manifestacion": self.id_manifestacion_actual,
          "id_usuario": self.$local_storage.get("id_usuario"),
          "id_cliente": self.$local_storage.get("id_cliente")

        };

        axios.post(self.$hostname + "vucem/solicitud_edocs_agente/", data2)
          .then(res => {
          })
          .catch(err => {
            console.log(err);
          }).then(() => {
          });
      }

    },

  }, //methods

  mounted: function () {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname + "manifestacion/";
    //this.URL = "http://127.0.0.1:7000/manifestacion/";
    this.cliente = this.$local_storage.get("id_cliente");
    this.model.usuario_email = this.$local_storage.get("email");
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.rfc_emisor = this.$local_storage.get("rfc");
    this.model_nuevo.rfc = this.$local_storage.get("rfc");
    this.model_nuevo.rfc_emisor = this.$local_storage.get("rfc");
    this.rfc = this.model.rfc;
    this.cargarEmisores();
    this.cargarRfcsConsulta();
    this.cargarRepresentantes();
    this.cargarSolicitudes(0);
    //this.cargarCertificados();

    var permiso_patentes = this.$local_storage.get("Emanifiesto.Logistico.manifestacion", "");
    if (permiso_patentes.toString() == "100") {//Los que tengan este permiso solo pueden crear manifestaciones de sus patentes
      this.getAgentesPatentes();
      this.permisoPatentes = "100";
    }



    var f = new Date();
    var f_de = new Date();
    f_de.setDate(f_de.getDate() - 15);


    let y_de = f_de.getFullYear();
    let m_de = f_de.getMonth() + 1;
    let d_de = f_de.getDate();

    if (m_de < 10)
      m_de = '0' + m_de;
    if (d_de < 10)
      d_de = '0' + d_de;

    let y = f.getFullYear();
    let m = f.getMonth() + 1;
    let d = f.getDate();


    if (m < 10)
      m = '0' + m;
    if (d < 10)
      d = '0' + d;


    this.fecha_a = y + "-" + m + "-" + d;
    this.fecha_de = y_de + "-" + m_de + "-" + d_de;
    this.cargar()
  }
};
</script>
<style scoped>
.manual>table>tr {
  page-break-inside: avoid
}

.title-table {
  font-weight: bold !important;
  background-color: lightgray !important;
}

.manual>table {
  width: 100%;
  border-collapse: collapse;
}

.manual>table,
td {
  padding-left: 2px;
  border: 1px solid #282828;
  height: 20px;
}

.titulo-principal {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.manual {
  margin: 0px;
  padding: 0px;
  /*height: auto;
    width: auto;
    background-color: #fff;*/
  text-align: justify;
  font-family: Arial;
  font-size: 0.90rem;
}

.elevation-1>>>.columnaError {
  white-space: normal !important;
  min-width: 300px !important;
  text-align: justify !important;
}
</style>
